export default __webpack_public_path__ + "static/media/Treads of the Outer Dark.f20f2433.jpg";